import React, { useRef } from "react";
import {
	Form,
	Input,
	Button,
	List,
	Typography,
	Flex,
	Popconfirm,
	message,
	Modal,
	Tag,
	Alert,
	Spin,
} from "antd";
import { useState } from "react";
import {
	useAddTemplateMutation,
	useDeleteTemplateMutation,
	useGetKeywordsQuery,
	useGetTemplatesQuery,
	useUpdateTemplateMutation,
} from "@/redux/services/phoneTemplateApi";

const TagColor = [
	"magenta",
	"red",
	"volcano",
	"orange",
	"gold",
	"lime",
	"green",
	"cyan",
	"blue",
	"geekblue",
	"purple",
	"processing",
];

const getColor = (index) => {
	const colorIndex = index % TagColor.length; // 取余确保索引不会超出数组范围
	return TagColor[colorIndex];
};

// const KEY_WORDS = [
// 	"firstname",
// 	"lastname",
// 	"product_shortname",
// 	"location",
// 	"car",
// 	"driver_name",
// 	"phone",
// 	"pickup_time",
// ];

const setCursorPosition = (ctrl, start, end) => {
	ctrl.focus();
	if (ctrl?.resizableTextArea?.textArea.selectionStart) {
		ctrl.resizableTextArea.textArea.selectionStart = start;
	}
	if (ctrl?.resizableTextArea?.textArea.selectionEnd) {
		ctrl.resizableTextArea.textArea.selectionEnd = end;
	}
};

const example =
	"你好 {{ client_name }} ，你的旅程 {{ subtitle }} 的上车地点是 {{ pickup_location }} ，车牌号码是： {{ vehicle_plate_number }} ";

function checkAllKeywordsMatch(text, KEY_WORDS) {
	if (KEY_WORDS == null || KEY_WORDS.length === 0) return false;
	const regex = /{{\s*([^}\s]+)\s*}}/g;
	let match;

	while ((match = regex.exec(text)) !== null) {
		const variable = match[1];
		if (!KEY_WORDS.includes(variable)) {
			return false; // 如果找到的变量不在KEY_WORDS数组中，则返回false
		}
	}

	return true; // 如果所有变量都在KEY_WORDS数组中，则返回true
}

const AddTemplate = () => {
	const [form] = Form.useForm();
	const [isOpen, setIsOpen] = useState(false);
	const formRef = useRef();
	const cursorRef = useRef(null);

	const [addTemplate] = useAddTemplateMutation();
	const { refetch } = useGetTemplatesQuery();
	const { data: KEY_WORDS } = useGetKeywordsQuery();

	const handleKeywordOnClick = (keyword) => {
		const cursor = cursorRef?.current?.resizableTextArea?.textArea;
		const formInstance = formRef.current;
		// 获取当前 TextArea 的值
		const currentValue = formInstance.getFieldValue("template");

		if (cursor == null || formInstance == null) return;

		// 获取光标位置
		const selectionStart = cursor.selectionStart;

		let newValue = "";
		if (currentValue) {
			newValue =
				currentValue.substring(0, selectionStart) +
				" {{ " +
				keyword +
				" }} " +
				currentValue.substring(selectionStart);
		} else {
			newValue = "{{ " + keyword + " }} ";
		}

		// 更新 Form.Item 中的 TextArea 的值
		formInstance.setFieldsValue({ template: newValue });

		// 获取新的 TextArea 元素
		const textArea = formInstance.getFieldInstance("template");

		// 设置光标位置为文本末尾
		textArea.selectionStart = textArea.selectionEnd = newValue.length;

		setTimeout(() => {
			setCursorPosition(
				cursorRef?.current,
				newValue.length,
				newValue.length
			);
		}, 200);
	};
	const onFinish = async (values) => {
		if (checkAllKeywordsMatch(values.template, KEY_WORDS)) {
			// try {
			// 	await addTemplate({
			// 		templateName: values.name,
			// 		templateContent: values.template,
			// 	});
			// 	form.resetFields();
			// 	message.success("Create successful");
			// 	await refetch();
			// } catch (error) {
			// 	message.error("Something went wrong...");
			// }

			await addTemplate({
				templateName: values.name,
				templateContent: values.template,
			})
				.unwrap()
				.then((payload) => {
					form.resetFields();
					message.success("Create successful");
					refetch();
					setIsOpen(false);
				})
				.catch((error) => message.error("Something went wrong..."));
		} else {
			message.error("Please follow up template example");
		}
	};

	const handleCancel = () => {
		form.resetFields();
		setIsOpen(false);
	};

	return (
		<div>
			<Button
				style={{ marginBottom: "30px" }}
				onClick={() => setIsOpen(true)}
			>
				新模版
			</Button>
			<Modal
				title="Create A Phone Template"
				open={isOpen}
				onCancel={handleCancel}
				footer={[
					<Button key="cancel" onClick={handleCancel}>
						Cancel
					</Button>,
				]}
				width="80%"
			>
				<div>
					<Typography>
						<Typography.Text type="secondary" strong>
							<h5>Keyword</h5>
						</Typography.Text>
					</Typography>
					<Flex gap="4px" wrap="wrap">
						{KEY_WORDS &&
							KEY_WORDS.map((key, index) => (
								<Tag
									key={index}
									color={getColor(index)}
									onClick={() => handleKeywordOnClick(key)}
									style={{ cursor: "pointer" }}
								>
									{key}
								</Tag>
							))}
					</Flex>
				</div>
				<Form
					form={form}
					onFinish={onFinish}
					layout="vertical"
					style={{ marginTop: "30px" }}
					ref={formRef}
				>
					<Form.Item
						name="name"
						label="Template Name"
						rules={[{ required: true, message: "请输入模版名字" }]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="template"
						label="Template"
						rules={[{ required: true, message: "请输入模版内容" }]}
					>
						<Input.TextArea rows={8} ref={cursorRef} />
					</Form.Item>

					<Form.Item>
						<Button type="primary" htmlType="submit">
							Generate Template
						</Button>
					</Form.Item>
				</Form>
				<Alert
					type="info"
					showIcon
					message="Template Example"
					description={example
						.split(/(\{\{.*?\}\})/)
						.map((part, index) => {
							if (part.match(/\{\{.*?\}\}/)) {
								return <span key={index}>{part}</span>; // 使用span标签包裹双大括号的内容
							}
							return part; // 其他部分直接返回
						})}
				/>
			</Modal>
		</div>
	);
};

const EditTemplate = ({ template }) => {
	const [form] = Form.useForm();
	const [updateTemplate] = useUpdateTemplateMutation();
	const { refetch } = useGetTemplatesQuery();
	const { data: KEY_WORDS } = useGetKeywordsQuery();

	const [isOpen, setIsOpen] = useState(false);

	const formRef = useRef();
	const cursorRef = useRef(null);

	const handleKeywordOnClick = (keyword) => {
		const cursor = cursorRef?.current?.resizableTextArea?.textArea;
		const formInstance = formRef.current;

		if (cursor == null || formInstance == null) return;

		// 获取光标位置
		const selectionStart = cursor.selectionStart;

		// 获取当前 TextArea 的值
		const currentValue = formInstance.getFieldValue("template");

		let newValue = "";
		if (currentValue) {
			newValue =
				currentValue.substring(0, selectionStart) +
				" {{ " +
				keyword +
				" }} " +
				currentValue.substring(selectionStart);
		} else {
			newValue = "{{ " + keyword + " }} ";
		}

		// 更新 Form.Item 中的 TextArea 的值
		formInstance.setFieldsValue({ template: newValue });

		// 获取新的 TextArea 元素
		const textArea = formInstance.getFieldInstance("template");

		// 设置光标位置为文本末尾
		textArea.selectionStart = textArea.selectionEnd = newValue.length;

		setTimeout(() => {
			setCursorPosition(
				cursorRef?.current,
				newValue.length,
				newValue.length
			);
		}, 200);
	};

	const handleCancel = () => {
		form.resetFields();
		setIsOpen(false);
	};

	const onFinish = async (values) => {
		if (checkAllKeywordsMatch(values.template, KEY_WORDS)) {
			// try {
			// 	await updateTemplate({
			// 		templateId: template.id,
			// 		templateName: values.name,
			// 		templateContent: values.template,
			// 	});
			// 	message.success("Update successful");
			// 	await refetch();
			// } catch (error) {
			// 	message.error("Something went wrong...");
			// }

			await updateTemplate({
				templateId: template.id,
				templateName: values.name,
				templateContent: values.template,
			})
				.unwrap()
				.then((payload) => {
					message.success("Update successful");
					refetch();
				})
				.catch((error) => message.error("Something went wrong..."));
		} else {
			message.error("Please follow up template example");
		}
	};

	return (
		<div>
			<Button onClick={() => setIsOpen(true)}>Edit</Button>
			<Modal
				title="Edit Phone Template"
				open={isOpen}
				onCancel={handleCancel}
				footer={[
					<Button key="cancel" onClick={handleCancel}>
						Cancel
					</Button>,
				]}
				width="80%"
			>
				<div>
					<Typography>
						<Typography.Text type="secondary" strong>
							<h5>Keyword</h5>
						</Typography.Text>
					</Typography>
					<Flex gap="4px" wrap="wrap">
						{KEY_WORDS &&
							KEY_WORDS.map((key, index) => (
								<Tag
									key={index}
									color={getColor(index)}
									onClick={() => handleKeywordOnClick(key)}
									style={{ cursor: "pointer" }}
								>
									{key}
								</Tag>
							))}
					</Flex>
				</div>
				<Form
					form={form}
					onFinish={onFinish}
					layout="vertical"
					style={{ marginTop: "30px" }}
					ref={formRef}
					initialValues={template}
				>
					<Form.Item
						name="name"
						label="Template Name"
						rules={[{ required: true }]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="template"
						label="Template"
						rules={[{ required: true }]}
					>
						<Input.TextArea rows={8} ref={cursorRef} />
					</Form.Item>
					<Form.Item>
						<Button type="primary" htmlType="submit">
							Update Template
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
};

const PhoneTemplate = () => {
	const { data, isLoading, isError, refetch } = useGetTemplatesQuery();
	const [deleteTemplate] = useDeleteTemplateMutation();
	const { isError: isKeywordError } = useGetKeywordsQuery();

	const handleDelete = async (item) => {
		// try {
		// 	await deleteTemplate(item.id);
		// 	message.success(`${item.name} delete successful!`);
		// 	refetch();
		// } catch {
		// 	message.error("something went wrong");
		// }

		await deleteTemplate(item.id)
			.unwrap()
			.then((payload) => {
				message.success("delete successful");
				refetch();
			})
			.catch((error) => message.error("Something went wrong..."));
	};

	if (isLoading) {
		return <Spin />;
	}

	if (isError || isKeywordError) {
		return <div>something went wrong</div>;
	}
	return (
		<div>
			<AddTemplate />
			<List
				bordered
				dataSource={data}
				renderItem={(item) => (
					<List.Item>
						<Typography>{item.name}</Typography>
						<Flex gap={"small"}>
							<EditTemplate template={item} />
							<Popconfirm
								title="Delete the Template"
								description="Are you sure to delete this template?"
								onConfirm={() => handleDelete(item)}
								okText="Yes"
								cancelText="No"
							>
								<Button danger>Delete</Button>
							</Popconfirm>
						</Flex>
					</List.Item>
				)}
			/>
		</div>
	);
};

export default PhoneTemplate;
